/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportSubscriptionAuthSupportsCustom$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function exportSubscriptionAuthSupportsCustom(http: HttpClient, rootUrl: string, params: ExportSubscriptionAuthSupportsCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportSubscriptionAuthSupportsCustom.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.ms-excel', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportSubscriptionAuthSupportsCustom.PATH = '/custom/subscriptions/{uid}/auth-supports/export';
